<script lang="ts">
    
    import {type Meeting} from './src/types';
    import MatchRow from './PlayerMeetingMatchRow.svelte';

    export let meeting:Meeting;

    export let displaySheet : (id: number) => void  = (id:number) => {};

</script>

<table on:click={(e) => {e.preventDefault(); displaySheet(meeting.sheetId);}}>
<tr><td colspan="10" style="font-weight: bold; text-align: left;padding-left: 25px;">{meeting.matches[0].team}</td></tr>
{#each meeting.matches as match}		
<tr>
    <MatchRow {match}/>    
{/each}

{#if !(meeting.matches[0].double)}
<tr ><td colspan="7" style="border-bottom: 1px solid;">&nbsp;</td>
    <td style="border-bottom: 1px solid;">{meeting.totalGain > 0 ?  "↗️" : "↘️"} {Math.abs(meeting.totalGain)}</td>
    <td style="border-bottom: 1px solid;" colspan="2">&nbsp;</td></tr>
{/if}
</table>
